'use strict'

export const DATAPARAMETERS = {
  ADVERTISERID: 'ai',
  CAMPAIGNID: 'ci',
  CAMPAIGNSOLUTIONID: 'csi',
  THEMEID: 'thi',
  STORYBOARDID: 'si',
  TEMPLATEID: 'ti',
  TEMPLATETYPE: 'tt',
  ISPREVIEW: 'ip',
  INVENTORYIDS:'ii',
  INVENTORIES:'inv',
  TABNAME: 'tn',
  MEDIACHANNELID: 'mci',
  FORMAT: 'fmt',
  MODE: 'mo',
}